import React from 'react';
export var DayContentCell = function (_a) {
    var backgroundColor = _a.backgroundColor, color = _a.color, content = _a.content, opacity = _a.opacity, date = _a.date, onContextMenu = _a.onContextMenu;
    return (React.createElement("div", { onContextMenu: function (e) { return onContextMenu(date, e.nativeEvent, {}); }, style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            backgroundColor: backgroundColor,
            opacity: opacity,
            height: '100%'
        } },
        React.createElement("h1", { className: "fc-content-day", style: {
                color: color
            } }, content)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/PriceCalendar/DayContentCell.tsx
// module id = 1532
// module chunks = 0